import { useState } from "react";
import { Link } from "react-router-dom";
import { IoClose } from "react-icons/io5";

const CustomerList = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const customers = [
    {
      name: "John DoE",
      phone: "+91 9566546542",
      debt: -74,
      email: "john@example.com",
      gender: "Male",
    },
    {
      name: "Jane Smith",
      phone: "+91 9876543210",
      debt: -24,
      email: "jane@example.com",
      gender: "Female",
    },
  ];

  const [amount, setAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("All");
  const [sendSMS, setSendSMS] = useState(false);

  const paymentModes = ["All", "Cash", "UPI", "Debit Card", "Credit Card", "Pay Later"];

  return (
    <div className="p-2 sm:p-4">
      <h2 className="text-base sm:text-lg font-semibold mb-3 text-center md:text-left">
        Customer Management
      </h2>

      <div className="space-y-3 sm:space-y-4">
        {customers.map((c, i) => (
          <div key={i}>
            {/* Summary Card */}
            <div
              onClick={() =>
                setExpandedIndex(expandedIndex === i ? null : i)
              }
              className="cursor-pointer flex flex-col rounded-lg sm:flex-row sm:justify-between sm:items-center shadow-md p-6 sm:p-3 border gap-3 sm:gap-4"
            >
              <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4 w-full">
                {/* Avatar */}
                <Link
                  to="#"
                  className="w-10 h-10 sm:w-14 sm:h-14 bg-gray-300 rounded-full flex items-center justify-center text-white text-sm sm:text-lg font-bold"
                >
                  {c.name[0]}
                </Link>

                {/* Info */}
                <div className="mt-1 sm:mt-0 w-full">
                  <div className="flex justify-between items-center">
                    <span className="font-medium text-sm sm:text-base">
                      {c.name}
                    </span>
                    {c.debt < 0 && (
                      <span className="text-red-500 font-bold text-sm sm:text-base">
                        ${c.debt.toFixed(2)}
                      </span>
                    )}
                  </div>
                  <div className="text-xs sm:text-sm text-gray-500">
                    {c.phone}
                  </div>

                  <div className="flex flex-wrap gap-1 sm:gap-2 mt-2">
                    <button className="bg-primary text-white text-[10px] sm:text-xs px-2 sm:px-3 py-1 rounded-full">
                      Order-1
                    </button>
                    <button className="bg-primary text-white text-[10px] sm:text-xs px-2 sm:px-3 py-1 rounded-full">
                      11 days ago
                    </button>
                    <button className="bg-primary text-white text-[10px] sm:text-xs px-2 sm:px-3 py-1 rounded-full">
                      Due customer
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Expanded Details */}
            {expandedIndex === i && (
              <div className="bg-gray-50 border border-gray-300 rounded-lg p-4 mt-2 text-sm sm:text-base">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <p><strong>Name:</strong> {c.name}</p>
                  <p><strong>Email:</strong> {c.email}</p>
                  <p><strong>Mobile No:</strong> {c.phone}</p>
                  <p><strong>Gender:</strong> {c.gender}</p>
                  <p><strong>Balance Due:</strong> ${Math.abs(c.debt).toFixed(2)}</p>
                </div>
                <div className="mt-4">
                  <button
                    onClick={() => setShowModal(true)}
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition"
                  >
                    Receive Amount
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md relative p-6">
            {/* Close Icon */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-black"
            >
              <IoClose size={24} />
            </button>

            {/* Header */}
            <h2 className="text-lg font-semibold mb-4 text-center">Receive Amount</h2>

            {/* Amount Input */}
            <input
              type="number"
              placeholder="Enter Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full border rounded px-3 py-2 mb-4"
            />

            {/* Payment Modes */}
            <div className="grid grid-cols-2 gap-2 mb-4">
              {paymentModes.map((mode) => (
                <label
                  key={mode}
                  className={`cursor-pointer px-3 py-1 rounded-full text-sm border text-center ${
                    paymentMode === mode
                      ? "bg-primary text-white"
                      : "bg-gray-100 text-gray-700"
                  }`}
                  onClick={() => setPaymentMode(mode)}
                >
                  {mode}
                </label>
              ))}
            </div>

            {/* Send SMS */}
            <div className="flex items-center mb-4">
              <input
                type="checkbox"
                checked={sendSMS}
                onChange={() => setSendSMS(!sendSMS)}
                className="mr-2"
              />
              <label className="text-sm text-gray-700">Send SMS</label>
            </div>

            {/* Add Button */}
            <button
              className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700 transition"
              onClick={() => {
                console.log({ amount, paymentMode, sendSMS });
                setShowModal(false);
              }}
            >
              Add Amount
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerList;
